import React from "react";

import "../../styles/components/atoms/HorizontalRule.scss";

function HorizontalRule({ color }) {
  return <hr className="horizontal-rule" style={ color && {borderColor: color}} />;
}

export default HorizontalRule;
